var path = '/pages/guestlists/views/pages/rsvps/toolsets/rsvp-list-stats.tpl.html';
var html = "<div class=\"quick-stats\" ng-if=\"vm.store.state.vm.guestlist\">\n    <span><strong>{{vm.store.state.pagination.total}}</strong>&nbsp;&nbsp;records</span>\n    <span><strong>{{vm.store.state.stats.sum_pax_planned}}</strong>&nbsp;&nbsp;PAX</span>\n    <span><strong>{{vm.store.state.stats.sum_pax_actual}}</strong>&nbsp;&nbsp;checked in PAX</span>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/guestlists/views/pages/rsvps/toolsets/rsvp-list-stats.tpl.html
// module id = 2287
// module chunks = 1